import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { ActionSheetController, ModalController } from '@ionic/angular';
import { AppComponent } from 'src/app/app.component';
import { AuthService } from 'src/app/services/auth.service';
import { TimelineService } from 'src/app/services/timeline.service';
import { PeekAccountPage } from '../peek-account/peek-account.page';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.page.html',
  styleUrls: ['./maps.page.scss'],
})
export class MapsPage implements OnInit {

  public static pinezki = [];
  public static wasHere = false;


  modal;
  subpage = 'mapa';
  phaserGame: Phaser.Game;
  config: Phaser.Types.Core.GameConfig;
  account;

  accounts = [];

  zoomPercent = 30;
  

  constructor(private router: Router, private actionSheetController: ActionSheetController, public modalController: ModalController,
              public afa: AngularFireAuth, private auth: AuthService, private app: AppComponent, private timelineService: TimelineService)
  {
    this.config = {
        type: Phaser.AUTO,
        width: '100%',
        height: '100%',
        physics: {
            default: 'arcade'
        },
        parent: 'game',
        scene: MapScene
    };
  }

  ionViewWillEnter()
  {
    if (MapsPage.wasHere)
    {
       // console.log('!!!!!! was here');
      window.location.reload();
      return;
    }
  }

  goBackToStart()
  {

    this.router.navigate(['/p3']);
  }



  ionViewDidEnter()
  {
    // this.auth.presentRenderWarningOptions();

  }

  ngOnInit() {
     // console.log('mapa ini');
    this.afa.authState.subscribe(user => {
      if (user)
      {
        this.account = user;
         // console.log('profile user', this.account.uid);
        this.timelineService.appPages[1].url = '/profile/' + this.account.uid;
        // this.auth.czekAccount();
      }
      else {

         // console.log('BRAK KOLO');
        // this.isLoggedIn = false;
      }

      

      this.auth.getRecentKompasData().subscribe((data: any) => {
        MapsPage.pinezki = [];
        this.accounts = [];

         // console.log('getRecentKompasData', data);
        if (data === undefined)
        {
           // console.log('brak punktow');
        }
        else
        {
          data.map(a => {
            const dataKompasa = a.payload.doc.data();
            const uid = a.payload.doc.id;
            dataKompasa.uid = uid;
            let  isItMe = false;
            if (user && uid === this.account.uid)
            {
              isItMe = true;
            }
            dataKompasa.isItMe = isItMe;
            //  // console.log('ID', dataKompasa);
            MapsPage.pinezki.push(dataKompasa);
            if (!dataKompasa.avatar)
            {
              dataKompasa.avatar = 'assets/avatars/male/11.svg';
            }
            this.accounts.push(dataKompasa);
          });
           // console.log('MapsPage.pinezki przed', MapsPage.pinezki);
          MapsPage.wasHere = true;
          this.phaserGame = new Phaser.Game(this.config);
        }
      });
    });
  }

  gotoMyProfile()
  {
    if (this.account)
    {
      const domain = window.location.protocol + '//' + window.location.host + '/profile/' + this.account.uid;
      window.location.replace(domain);
    }
    else
    {
      this.router.navigate(['/p3']);
    }
  }

  zoomChanged(evt)
  {
     // console.log('zoom', this.zoomPercent);
    localStorage.setItem('zoom', this.zoomPercent.toString());
  }


  presentMenuActionSheet()
  {
     // console.log('presentMenuActionSheet');
    this.presentActionSheet();
  }
  async presentActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Co chcesz zrobić?',
      mode: 'md',
      buttons: [
      {
        text: 'Wróć do strony głównej',
        icon: 'home',
        handler: () => {
           // console.log('Otwieraj clicked');
          this.router.navigate(['/p3']);
        }
      }, {
        text: 'Otwórz swój Kompas',
        icon: 'navigate-circle',
        handler: () => {
           // console.log('Otwieraj clicked');
          // this.router.navigate(['/profile/', this.account.uid]);
          let domain;
          if (this.account)
          {
            domain = window.location.protocol + '//' + window.location.host + '/profile/' + this.account.uid;
          }
          else
          {
            domain = window.location.protocol + '//' + window.location.host + '/p3/';
          }
          window.location.replace(domain);
        }
      }, {
        text: 'Cofnij...',
        icon: 'close',
        role: 'cancel',
        handler: () => {
           // console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }

  openProfile(pro)
  {
     // console.log('openProfile', pro.uid);
    this.auth.peekingProfile = pro;
    this.presentModal();
  }

  async presentModal() {
    this.modal = await this.modalController.create({
      component: PeekAccountPage,
      cssClass: 'youTubePlayer'
    });
    return await this.modal.present();
  }

  changeTab(tab)
  {
    //  // console.log('changeTab', tab.detail.value);
    const gameDiv = document.getElementById('game') as HTMLDivElement;
    if (tab.detail.value === 'mapa')
    {
       // console.log('mapa');
      // gameDiv.setAttribute('width', '100%');
    }
    else if (tab.detail.value === 'list')
    {
       // console.log('list');
      // gameDiv.setAttribute('width', '0');
    }
  }
}



declare var Phaser;

class MapScene extends Phaser.Scene {


  mapWidth = 2912;
  mapHeight = 2912;
  whereX = 0;
  whereY = 0;
  animTarget = null;
  animTextTarget = null;

  pad;
  pin;

  constructor(config) {
      super(config);
  }

  preload() {

     // console.log('preload');
    this.load.image('map', 'assets/images/map.jpg');
    this.load.image('ship', 'assets/images/kompasPiratowAlpha.png');
    this.load.image('pointer', 'assets/images/pointer.png');
    this.load.image('pin', 'assets/images/pin.png');

    this.load.image('authority', 'assets/kompas/value_images/authority.svg');
    this.load.image('equality', 'assets/kompas/value_images/equality.svg');
    this.load.image('liberty', 'assets/kompas/value_images/liberty.svg');
    this.load.image('might', 'assets/kompas/value_images/might.svg');
    this.load.image('peace', 'assets/kompas/value_images/peace.svg');
    this.load.image('progress', 'assets/kompas/value_images/progress.svg');
    this.load.image('tradition', 'assets/kompas/value_images/tradition.svg');
    this.load.image('wealth', 'assets/kompas/value_images/wealth.svg');
  }

  update() {
    const cam = this.cameras.main;

    let zoomPercent: any = localStorage.getItem('zoom');
    if (!zoomPercent)
    {
      zoomPercent = 30;
    }

    const jakiToNum: number = zoomPercent as number;
    cam.zoomTo(1 * jakiToNum * 1 / 100, 100);

  }

  create() {

    
     // console.log('create');

    this.cameras.main.setBounds(0, 0, this.mapWidth + 500, this.mapHeight + 500);
    this.game.events.on('destroy', () => {

       // console.log('destroy destroy');
    });

    const globalMap = this.add.image(0, 0, 'map').setOrigin(0);

    const circle0 = this.add.circle(this.mapWidth / 2, this.mapHeight / 2, 1190, 0x000000);
    circle0.setAlpha(0.12);
    circle0.disableInteractive();

    // rt.draw(circle0, 300, 300);

    const circle = this.add.circle(this.mapWidth / 2, this.mapHeight / 2, 900, 0x000000);
    circle.setAlpha(0.1);
    circle.disableInteractive();

    // rt.draw(circle, 300, 300);

    const circle2 = this.add.circle(this.mapWidth / 2, this.mapHeight / 2, 600, 0x000000);
    circle2.setAlpha(0.1);
    circle2.disableInteractive();

    // rt.draw(circle2, 300, 300);

    const circle3 = this.add.circle(this.mapWidth / 2, this.mapHeight / 2, 300, 0xFFFFFF);
    circle3.setAlpha(0.15);
    circle3.disableInteractive();


     // console.log('MapsPage.pinezki[0]', MapsPage.pinezki[0]);

    // prawa obywatelskie
    let g; // = MapsPage.pinezki[0].g;
    // swiatopoglad
    let s; // = MapsPage.pinezki[0].s;
    // economy
    let e; // = MapsPage.pinezki[0].e;
    // diplomacy
    let d; // = MapsPage.pinezki[0].d;

    const resztaPinezek = [];

    MapsPage.pinezki.forEach(pinezka => {
      if (pinezka.isItMe)
      {
        g = pinezka.g;
        s = pinezka.s;
        e = pinezka.e;
        d = pinezka.d;
         // console.log('to moj akwenik', pinezka);
      }
      else
      {
        const pinek = {
          x: Math.random(),
          uid: pinezka.uid,
          data: pinezka,
          y: Math.random(),
        };
        resztaPinezek.push(pinek);
      }
    });

     // console.log('resztaPinezek', resztaPinezek);

    const dlugoscLinii = this.mapWidth;
    const graphicsT = this.add.graphics({ fillStyle: { color: 0x00FFFF } });
    graphicsT.disableInteractive();


    const punktNaLiniiPrawaObyw = dlugoscLinii / 100 * g;
    const punktNaLiniiEkonomia = dlugoscLinii / 100 * e;
    const punktNaLiniiDyplo = dlugoscLinii / 100 * d;
    const punktNaLiniiSwiatopo = dlugoscLinii / 100 * s;

     // console.log('prawa', punktNaLiniiPrawaObyw, '/', dlugoscLinii, punktNaLiniiPrawaObyw / dlugoscLinii);
     // console.log('economy', punktNaLiniiEkonomia, '/', dlugoscLinii, punktNaLiniiEkonomia / dlugoscLinii);
     // console.log('diplomacy', punktNaLiniiDyplo, '/', dlugoscLinii, punktNaLiniiDyplo / dlugoscLinii);
     // console.log('swiatopoglad', punktNaLiniiSwiatopo, '/', dlugoscLinii, punktNaLiniiSwiatopo / dlugoscLinii);

    // freedom
    const xx1 = this.mapWidth / 2;
    const yy1 = this.mapHeight - punktNaLiniiPrawaObyw;

    // swiatopoglad
    const xx4 = punktNaLiniiSwiatopo;
    const yy4 = this.mapHeight / 2;

    // economy
    const xx2 = punktNaLiniiEkonomia / dlugoscLinii * dlugoscLinii;
    const yy2 = this.mapHeight - punktNaLiniiEkonomia / dlugoscLinii * dlugoscLinii;
    let mnoznik;
    let dodatek;

    if (punktNaLiniiEkonomia / dlugoscLinii > .5)
    {
      mnoznik = (punktNaLiniiEkonomia / dlugoscLinii - 0.5);
      dodatek = mnoznik * punktNaLiniiEkonomia * 0.7;
    }
    else
    {
      mnoznik = (punktNaLiniiEkonomia / dlugoscLinii);
      dodatek =  mnoznik * this.mapWidth;
    }

    // diplomacy
    const xx3 = punktNaLiniiDyplo / dlugoscLinii * dlugoscLinii;
    const yy3 = punktNaLiniiDyplo / dlugoscLinii * dlugoscLinii;


    const points = {
      x1: xx1,
      y1: yy1,
      x2: xx2,
      y2: yy2,
      x3: xx3,
      y3: yy3,
      x4: xx4,
      y4: yy4
    };

    const triangleDGE = new Phaser.Geom.Triangle(points.x1, points.y1, points.x2, points.y2, points.x3, points.y3);
    graphicsT.fillTriangleShape(triangleDGE);
    // const areaDGE = Phaser.Geom.Triangle.Area(triangleDGE);

    const triangleGES = new Phaser.Geom.Triangle(points.x2, points.y2, points.x3, points.y3, points.x4, points.y4);
    graphicsT.fillTriangleShape(triangleGES);

    const myIsland = {
      x: (points.x1 + points.x2 + points.x3 + points.x4) / 4,
      y: (points.y1 + points.y2 + points.y3 + points.y4) / 4
    };


    for (let index = 0; index < resztaPinezek.length; index++) 
    {
      const element = resztaPinezek[index];
      //  // console.log('poka pinexy', element.data);
      const jegopunktNaLiniiPrawaObyw = dlugoscLinii / 100 * element.data.g;
      const jegopunktNaLiniiEkonomia = dlugoscLinii / 100 * element.data.e;
      const jegopunktNaLiniiDyplo = dlugoscLinii / 100 * element.data.d;
      const jegopunktNaLiniiSwiatopo = dlugoscLinii / 100 * element.data.s;


      // freedom
      const jegoxx1 = this.mapWidth / 2;
      const jegoyy1 = this.mapHeight - jegopunktNaLiniiPrawaObyw;


      // swiatopoglad
      const jegoxx4 = jegopunktNaLiniiSwiatopo;
      const jegoyy4 = this.mapHeight / 2;

      // economy
      const jegoxx2 = jegopunktNaLiniiEkonomia / dlugoscLinii * dlugoscLinii;
      const jegoyy2 = this.mapHeight - jegopunktNaLiniiEkonomia / dlugoscLinii * dlugoscLinii;
      let mnoznik;
      let dodatek;

      if (jegopunktNaLiniiEkonomia / dlugoscLinii > .5)
      {
        mnoznik = (jegopunktNaLiniiEkonomia / dlugoscLinii - 0.5);
        dodatek = mnoznik * jegopunktNaLiniiEkonomia * 0.7;
        //  // console.log('ekonomia  MARKET', jegopunktNaLiniiEkonomia / dlugoscLinii, jegopunktNaLiniiEkonomia, mnoznik);
      }
      else
      {
        mnoznik = (jegopunktNaLiniiEkonomia / dlugoscLinii);
        dodatek =  mnoznik * this.mapWidth;
        //  // console.log('ekonomia  ROWNO', jegopunktNaLiniiEkonomia / dlugoscLinii, mnoznik, dodatek);
      }

      // diplomacy
      const jegoxx3 = jegopunktNaLiniiDyplo / dlugoscLinii * dlugoscLinii;
      const jegoyy3 = jegopunktNaLiniiDyplo / dlugoscLinii * dlugoscLinii;
      const jegopoints = {
        x1: jegoxx1,
        y1: jegoyy1,
        x2: jegoxx2,
        y2: jegoyy2,
        x3: jegoxx3,
        y3: jegoyy3,
        x4: jegoxx4,
        y4: jegoyy4
      };
      const jegoIsland = {
        x: (jegopoints.x1 + jegopoints.x2 + jegopoints.x3 + jegopoints.x4) / 4,
        y: (jegopoints.y1 + jegopoints.y2 + jegopoints.y3 + jegopoints.y4) / 4
      };

      /*
      const sprite = this.add.sprite(jegoIsland.x, jegoIsland.y, 'ball').setScale(1);
      //  The circle x/y relates to the top-left of the sprite.
      //  So if you want the circle positioned in the middle then you need to offset it by half the sprite width/height:
      const shape = new Phaser.Geom.Circle(46, 45, 45);
      sprite.setInteractive(shape, Phaser.Geom.Circle.Contains);
      sprite.on('pointerover',  () => {
          sprite.setTint(0x7878ff);
          this.tweens.add({
            targets: sprite,
            scale: .3,
            ease: 'Back.easeOut',
            yoyo: true,
            duration: 1000
          });
      });

      sprite.on('pointerout',  () => {
          sprite.clearTint();
          this.tweens.add({
            targets: sprite,
            scale: .1,
            ease: 'Back.easeOut',
            yoyo: true,
            duration: 1000
          });
      });
      */

      const jegopin = this.physics.add.image(jegoIsland.x, jegoIsland.y, 'pin').setOrigin(0.05, 0.95);
      jegopin.setScale(.08);

      const first3 = element.data.uid.substring(0, 5);
      const cutted = first3 + '...';
      const jegoPinText = this.add.text(jegoIsland.x - 0, jegoIsland.y + 1,
        cutted, {fontSize: 15, wordWrap: {width: 130, height: 80} });
      jegoPinText.setShadow(5, 5, '#000000', 5);
      jegopin.disableInteractive();
      jegoPinText.disableInteractive();
    }

    this.tweens.add({
      targets: graphicsT,
      alpha: .4,
      duration: 100
    });

    this.tweens.add({
      targets: graphicsT,
      delay: 500,
      alpha: .25,
      ease: 'Back.easeInOut',
      yoyo: true,
      duration: 5000,
      repeat: -1,
    });

    this.tweens.add({
      targets: circle0,
      alpha: 0.2,
      scale: 0.9,
      ease: 'Sine.easeInOut',
      yoyo: true,
      repeat: -1,
      duration: 6000
    });

    this.tweens.add({
      targets: circle,
      alpha: 0,
      ease: 'Sine.easeInOut',
      yoyo: true,
      scale: 1.15,
      repeat: -1,
      duration: 4500
    });

    this.tweens.add({
      targets: circle2,
      alpha: 0,
      ease: 'Sine.easeInOut',
      yoyo: true,
      scale: 1.15,
      repeat: -1,
      duration: 3000
    });

    this.tweens.add({
      targets: circle3,
      alpha: 0,
      scale: 1.15,
      ease: 'Sine.easeInOut',
      yoyo: true,
      repeat: -1,
      duration: 1500
    });

    this.tweens.add({
      targets: this.kotwica,
      scale: 1.15,
      alpha: .4,
      rotation: 2 * Math.PI,
      ease: 'Back.easeInOut',
      yoyo: true,
      delay: 500,
      duration: 70000,
      repeat: -1,
    });


    const graphics = this.add.graphics();
    graphics.lineStyle(2, 0x000000);

    // LINIA N/S
    graphics.beginPath();
    graphics.moveTo(this.mapWidth / 2, 0);
    graphics.lineTo(this.mapWidth / 2, this.mapHeight);
    graphics.closePath();
    graphics.strokePath();

    // LINIA W/E
    graphics.beginPath();
    graphics.moveTo(0, this.mapHeight / 2);
    graphics.lineTo(this.mapWidth, this.mapHeight / 2);
    graphics.closePath();
    graphics.strokePath();

    // LINIA ne/sw
    graphics.beginPath();
    graphics.moveTo(this.mapWidth, 0);
    graphics.lineTo(0, this.mapHeight);
    graphics.closePath();
    graphics.strokePath();

    // LINIA nw/se
    graphics.beginPath();
    graphics.moveTo(0, 0);
    graphics.lineTo(this.mapWidth, this.mapHeight);
    graphics.closePath();
    graphics.strokePath();

    const txtLiberty = 'Those with higher Liberty scores believe in strong civil liberties.';
    const txtEco = 'Those with higher Market scores believe the economy should be focused on rapid growth.';
    const txtPro = 'Those with higher Progress scores believe in social change and rationality.';
    const txtWorld = 'hose with higher Globe scores are cosmopolitan and globalist.';
    const txtAuth = 'Those with higher Authority scores believe in strong state power.';
    const txtEquali = 'Those with higher Equality scores believe the economy should distribute value evenly among the populace.';
    const txtTraditio = 'Those with higher Tradition scores believe in traditional values and strict adherence to a moral code.';
    const txtNarod = 'Those with higher Nation scores are patriotic and nationalist.';

    const authority = this.add.image(this.mapWidth / 2, this.mapHeight - 333 + 50, 'authority').setOrigin(0.5, 0.5).setInteractive({ cursor: 'url(assets/images/pointer.png), pointer' });
    const authorityText = this.add.text(this.mapWidth / 2 + 150, this.mapHeight - 333 - 50,
      txtAuth, {fontSize: 30, wordWrap: {width: 500} });
    authorityText.setShadow(5, 5, '#000000', 3);
    authorityText.setAlpha(0);

    authority.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
        //  // console.log('pointer', localX, localY);
        this.whereX = this.mapWidth / 2 + 300;
        this.whereY = this.mapHeight - 333 + 50;
        this.animTarget = authority;
        this.animTextTarget = authorityText;
    });

    const equality = this.add.image(2241 + 50, 697 - 25 - 50, 'equality').setOrigin(0.5, 0.5).setInteractive({ cursor: 'url(assets/images/pointer.png), pointer' });
    const equalityText = this.add.text(2241 + 50 - 125, 697 - 25 - 50 - 275, txtEquali, {fontSize: 30, wordWrap: {width: 600} });
    equalityText.setShadow(5, 5, '#000000', 3);
    equalityText.setAlpha(0);
    equality.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = 2241 + 50;
      this.whereY = 697 - 25 - 50;
      this.animTarget = equality;
      this.animTextTarget = equalityText;
    });

    const wealth = this.add.image(this.mapWidth - 2241 - 50,
      this.mapHeight - 697 + 25 + 50, 'wealth').setOrigin(0.5, 0.5).setInteractive({ cursor: 'url(assets/images/pointer.png), pointer' });
    const wealthText = this.add.text(this.mapWidth - 2241 - 50 - 125,
      this.mapHeight - 697 + 25 + 50 - 250,
      txtEco, {fontSize: 30, wordWrap: {width: 600} });
    wealthText.setShadow(5, 5, '#000000', 3);
    wealthText.setAlpha(0);
    wealth.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = this.mapWidth - 2241 - 50;
      this.whereY = this.mapHeight - 697 + 25 + 50;
      this.animTarget = wealth;
      this.animTextTarget = wealthText;
    });
    

    const liberty = this.add.image(this.mapWidth / 2, 333 - 70, 'liberty').setOrigin(0.5, 0.5).setInteractive({ cursor: 'url(assets/images/pointer.png), pointer' });
    const libertyText = this.add.text(this.mapWidth / 2 + 150, 333 - 70 - 125, txtLiberty, {fontSize: 30, wordWrap: {width: 500} });
    libertyText.setShadow(5, 5, '#000000', 3);
    libertyText.setAlpha(0);
    this.whereX = this.mapWidth / 2;
    this.whereY = 333 - 70;
    this.animTarget = liberty;
    this.animTextTarget = libertyText;
    liberty.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = this.mapWidth / 2 + 300;
      this.whereY = 333 - 70;
      this.animTarget = liberty;
      this.animTextTarget = libertyText;
    });
    
    const might = this.add.image(this.mapWidth - 2241 - 50, 697 - 25 - 50, 'might').setOrigin(0.5, 0.5).setInteractive({ cursor: 'url(assets/images/pointer.png), pointer' });
    const mightText = this.add.text(this.mapWidth - 2241 - 50 - 500, 697 - 75 - 125, txtNarod, {fontSize: 30, wordWrap: {width: 500} });
    mightText.setShadow(5, 5, '#000000', 3);
    mightText.setAlpha(0);
    might.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = this.mapWidth - 2241 - 50;
      this.whereY = 697 - 25 - 50;
      this.animTarget = might;
      this.animTextTarget = mightText;
    });
    
    
    const peace = this.add.image(2241 + 50, this.mapHeight - 697 + 25 + 50, 'peace').setOrigin(0.5, 0.5).setInteractive({ cursor: 'url(assets/images/pointer.png), pointer' });
    const peaceText = this.add.text(2241 + 50 - 425, this.mapHeight - 697 + 25 + 50 + 175,
      txtWorld, {fontSize: 30, wordWrap: {width: 700} });
    peaceText.setShadow(5, 5, '#000000', 3);
    peaceText.setAlpha(0);
    peace.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = 2241 + 50;
      this.whereY = this.mapHeight - 697 + 25 + 50;
      this.animTarget = peace;
      this.animTextTarget = peaceText;
    });
    
    
    const progress = this.add.image(2605 + 20 + 25, this.mapHeight / 2, 'progress').setOrigin(0.5, 0.5).setInteractive({ cursor: 'url(assets/images/pointer.png), pointer' });
    const progressText = this.add.text(2605 + 20 + 25 - 500, this.mapHeight / 2 - 210, txtPro, {fontSize: 30, wordWrap: {width: 700} });
    progressText.setShadow(5, 5, '#000000', 3);
    progressText.setAlpha(0);
    progress.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = 2605 + 20 + 25;
      this.whereY = this.mapHeight / 2;
      this.animTarget = progress;
      this.animTextTarget = progressText;
    });
    
    const tradition = this.add.image(this.mapWidth - 2605 - 20 - 25,
       this.mapHeight / 2, 'tradition').setOrigin(0.5, 0.5).setInteractive({ cursor: 'url(assets/images/pointer.png), pointer' });
    const traditionText = this.add.text(this.mapWidth - 2605 - 20 - 150, this.mapHeight / 2 + 150,
      txtTraditio, {fontSize: 30, wordWrap: {width: 700} });
    traditionText.setShadow(5, 5, '#000000', 3);
    traditionText.setAlpha(0);
    tradition.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = this.mapWidth - 2605 - 20 - 25;
      this.whereY = this.mapHeight / 2;
      this.animTarget = tradition;
      this.animTextTarget = traditionText;
    });
    
  
    // this.text = this.add.text(100, 100).setText('Ahoj marynarzu!').setScrollFactor(2);
    // this.text.setShadow(1, 1, '#FFFFFF', 2);

    this.cameras.main.setZoom(.3);
    this.cameras.main.centerOn(this.mapWidth / 2, this.mapHeight / 2);

    this.cursors = this.input.keyboard.createCursorKeys();
    this.kotwica = this.physics.add.image(this.mapWidth / 2 - 6, this.mapHeight / 2, 'ship');
    this.kotwica.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = this.mapWidth / 2 + 100;
      this.whereY = this.mapWidth / 2;
      this.animTarget = this.kotwica;
    });

    this.ship = this.physics.add.image(myIsland.x, myIsland.y, 'pointer').setOrigin(0.5, 0.5);

    this.pin = this.physics.add.image(myIsland.x, myIsland.y, 'pin').setOrigin(0.05, 0.95);
    this.pin.setScale(.5);
    // this.pin.setInteractive(this.pin, Phaser.Geom.Circle.Contains);
    this.pin.disableInteractive();



    this.tweens.add({
      targets: this.kotwica,
      scale: 1.15,
      alpha: .4,
      rotation: 2 * Math.PI,
      ease: 'Back.easeInOut',
      yoyo: true,
      delay: 500,
      duration: 70000,
      repeat: -1,
    });
    let pos = 0;


    let isBlocked = false;


    this.input.on('pointerup', function() {

        if (isBlocked)
        {
          return;
        }

        isBlocked = true;

        const cam = this.cameras.main;


        if (pos === 0)
        {
            cam.pan(this.whereX, this.whereX, 3000, 'Cubic.easeOut');
            cam.zoomTo(.9, 3000);
            pos++;
            this.tweens.add({
              targets: this.animTarget,
              scale: 1.1,
              ease: 'Back.easeInOut',
              yoyo: true,
              delay: 2000,
              duration: 1000
            });
            this.tweens.add({
              targets: this.animTextTarget,
              alpha: 1,
              ease: 'Back.easeInOut',
              delay: 2500,
              duration: 1000
            });

            
            setTimeout(() => { isBlocked = false; }, 3000);
            // pos = 9;

        }
        else if (pos === 1)
        {
          // wolnosc
            cam.pan(this.mapWidth / 2, this.mapWidth / 2, 1000, 'none');
            cam.zoomTo(.3, 1000, 'Sine.easeOut');
            this.tweens.add({
              targets: this.animTextTarget,
              alpha: 0,
              ease: 'Back.easeInOut',
              duration: 700,
              delay: 500
            });
            setTimeout(() => { isBlocked = false; }, 1000);
            pos = 0;
        }

    }, this);
  }
}
